export default __webpack_public_path__ + "static/media/IconDesc_ModularFrame.256.2a61af86.png";